/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { defaultTheme } from '@vital-ui/react-theme';
import { trunTo, superBoxStyle, } from '@vital-ui/react-utils';
import cn from 'classnames';
var inverseOrNot = function (_a) {
    var inverse = _a.inverse, theme = _a.theme;
    return "\n  background-color: " + (inverse ? theme.badge.inverseBg : theme.badge.bg) + ";\n  color: " + (inverse ? theme.badge.inverseColor : theme.badge.color) + ";\n";
};
var Root = styled('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  padding: 0.25rem 0.75rem;\n  border-radius: 0.75rem;\n  font-size: 0.725rem;\n\n  ", ";\n  ", ";\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  padding: 0.25rem 0.75rem;\n  border-radius: 0.75rem;\n  font-size: 0.725rem;\n\n  ", ";\n  ", ";\n"])), inverseOrNot, superBoxStyle);
Root.defaultProps = {
    theme: defaultTheme,
};
/**
 * @render react
 * @name Badge
 * @description Vital UI Kit Badge Label
 * @example
 * <Badge>99</Badge>
 */
export var Badge = function (_a) {
    var children = _a.children, _b = _a.trunc, trunc = _b === void 0 ? true : _b, _c = _a.inverse, inverse = _c === void 0 ? false : _c, className = _a.className, style = _a.style, props = __rest(_a, ["children", "trunc", "inverse", "className", "style"]);
    return (React.createElement(Root, __assign({ inverse: inverse, className: cn('vital__badge', className), style: style }, props), (trunc && typeof children === 'string') ||
        typeof children === 'number'
        ? trunTo(children)
        : children));
};
var templateObject_1;
//# sourceMappingURL=Badge.js.map